import {CommunicationBulkAction } from '@/actions/components/bulk-action-modal/communication-bulk-action';
import { Button, ComponentStyle } from "@/imports-files/components/candidate-bulk-action-modal";
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

export function CommunicationBulkActionModal(props)
{
    const router = useRouter();
const {t} = useTranslation()
    return(
            <div className={`CommunicationBulkAction ${ComponentStyle.CandidateBulkActionSection}`}>
                {router.query.email_type == 'inbox' && <Button buttonstyle={ComponentStyle.primarybtn} onClick={() => {new CommunicationBulkAction(router, t).bulk_mark_as_read(props)}}>{t('button:mark_as_read')}</Button>}
                {router.query.email_type == 'inbox' &&<Button buttonstyle={ComponentStyle.primarybtn} onClick={() => {new CommunicationBulkAction(router, t).bulk_mark_as_unread(props)}}>{t('button:mark_as_unread')}</Button>}
                <Button buttonstyle={ComponentStyle.primarybtn} onClick={() => {new CommunicationBulkAction(router, t).bulk_dismiss(props)}}>{t('button:delete')}</Button>
            </div>
          )
}